import { select } from '@angular-redux/store';
import { Component, forwardRef, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Account } from "sharedFeatures/sharedModels";
import { BillingService, DialogCreationService } from "sharedFeatures/sharedServices";
import { isSuccessResponse } from "sharedFeatures/sharedServices/Responses";
import { SubscriptionCancelWinComponent } from 'sharedFeatures/subscription-cancel-win';
import { LoadingSpinnerService } from 'sharedGuiSmall/sharedServices/loadingSpinner.service';

@Component({
    selector: 'subscription-cancel-win-body',
    templateUrl: './subscription-cancel-win-body.component.html',
    styleUrls: ['./subscription-cancel-win-body.component.less']
})
export class SubscriptionCancelWinBodyComponent {

    subscriptionRef: string = '';
    // Unsubscribe event
    private storeUnsubscribe = new Subject<void>();

    @select(['account', 'accountData'])
    readonly accountData$!: Observable<Account>;

    constructor(
        private dialogCreation: DialogCreationService,
        private billingService: BillingService,
        @Inject(forwardRef(() => SubscriptionCancelWinComponent)) private parent: SubscriptionCancelWinComponent,
        private loadingSpinnerService: LoadingSpinnerService) {}

    ngOnDestroy() {
        // Unsubscribe from the redux store
        this.storeUnsubscribe.next();
        this.storeUnsubscribe.complete();
    }

    onCancel(): void {
        this.loadingSpinnerService.setLoading(true);
        this.parent.close();

        this.billingService.ChangeSubscriptionAutoRenew(this.subscriptionRef, false)
            .then((data) => {
                if (isSuccessResponse(data)) {
                    if (this.parent.billingComponent)
                        this.parent.billingComponent.RefreshSubscriptions();

                    //this.parent.hostWindow.setZIndex(PopupComponent.getTopestZ() + 1);
                }
                else {

                    const popup = this.dialogCreation.createErrorWarning("Error", data.errorMessage, () => { popup.close(); });
                    popup.show();

                }
            })
            .catch(error => {
                //this.dialogCreation.createUnknownExceptionDialog();
            });
    }

    onKeep(): void {
        //this.parent.hostWindow.setZIndex(PopupComponent.getTopestZ() + 1);
        this.parent.close();
    }

    public setSubscriptionRef(ref: string): void {
        this.subscriptionRef = ref;
    }
}
